import { fork } from 'redux-saga/effects';

import developmentFeatureRootSaga from './development-features'
import productFeatureRootSaga from './product-features'

export default function* featureRootSaga() {
    yield fork(developmentFeatureRootSaga);
    yield fork(productFeatureRootSaga);
}